export default {
  smss: [],
  smsTemplates: [],
  smsConfig: [],
};
